'use client'

import type { ReactNode } from 'react'

import cn from '@config/tailwind/cn'

import { useHasStickyBanner } from '~/context'
import { poppins } from '~/font'
import { Footer } from '~/lib/footer'
import { Navbar } from '~/lib/navbar'
import { StickyBanner } from '~/lib/sticky-banner'

export function MainLayoutClient({ children }: { children: ReactNode }) {
  const { hasStickyBanner } = useHasStickyBanner()

  return (
    <div className='relative h-fit min-h-dvh w-full'>
      <StickyBanner className={cn('h-[5dvh] max-h-[5dvh] min-h-[5dvh]', poppins.className)} />

      <Navbar className={cn('h-16', hasStickyBanner ? 'top-[5dvh]' : 'top-0')} />

      <div
        className={cn(
          hasStickyBanner
            ? // 'pt-[calc(5dvh+var(--spacing)*16)]'
              'pt-16'
            : 'pt-16',
        )}
      >
        {children}
      </div>

      <Footer />
    </div>
  )
}
